<script>
import Layout from '@layouts/overview.vue'
import clientGroupOverviewFeatureMixin from '@/mixins/clientGroupOverviewFeatureMixin'
import baseMixin from '@/mixins/baseMixin'
import ClientGroupOverviewContainer from '@/components/overview/client-group-overview-container.vue'

export default {
  name: 'ClientGroupOverviewView',
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [
        { name: 'description', content: 'The Client Group Overview page.' },
      ],
    }
  },
  components: { Layout, ClientGroupOverviewContainer },
  mixins: [baseMixin, clientGroupOverviewFeatureMixin],
}
</script>

<template>
  <Layout>
    <ClientGroupOverviewContainer />
  </Layout>
</template>
